import { render, staticRenderFns } from "./TheNavbarVertical.vue?vue&type=template&id=8cbd24bc"
import script from "./TheNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheNavbarVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cbd24bc')) {
      api.createRecord('8cbd24bc', component.options)
    } else {
      api.reload('8cbd24bc', component.options)
    }
    module.hot.accept("./TheNavbarVertical.vue?vue&type=template&id=8cbd24bc", function () {
      api.rerender('8cbd24bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/TheNavbarVertical.vue"
export default component.exports